export enum Req {
	failed = 'failed',
	success = 'success',
	token = 'token',
}
